import axios from "axios";

// httpClient.defaults.timeout = 500;
export default axios.create({
  baseURL: "https://video-convert-iovjvrkeja-uc.a.run.app",
  timeout : 20000,
},
);

